import {
  collection,
  deleteDoc,
  doc,
  getDoc,
  getDocs,
  setDoc,
} from "firebase/firestore";
import { db } from "../config/firebase";

const deletedEventsCollection = collection(db, "deleted_events");

const deletedEventService = {
  getAll: async () => {
    try {
      const deletedEventsSnapshot = await getDocs(deletedEventsCollection);
      const deletedEventsList = deletedEventsSnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      return deletedEventsList;
    } catch (error) {
      console.error("Error fetching deleted events:", error);
      throw error;
    }
  },

  restore: async (deletedEventId) => {
    try {
      const deletedEventRef = doc(db, "deleted_events", deletedEventId);
      const deletedEventSnap = await getDoc(deletedEventRef);

      if (deletedEventSnap.exists()) {
        const originalData = deletedEventSnap.data();
        const restoredRef = doc(db, "events", deletedEventId);

        await setDoc(restoredRef, {
          ...originalData,
          original_id: deletedEventId,
        });

        await deleteDoc(deletedEventRef);
        return restoredRef.id;
      }

      throw new Error("Deleted event not found");
    } catch (error) {
      console.error("Error restoring event:", error);
      throw error;
    }
  },

  delete: async (deletedEventId) => {
    try {
      const deletedEventRef = doc(db, "deleted_events", deletedEventId);
      await deleteDoc(deletedEventRef);
      return true;
    } catch (error) {
      console.error("Error permanently deleting event:", error);
      throw error;
    }
  },
};

export default deletedEventService;
